import { LayoutModule } from '../../../layout/modules';
import { CasesGeneralFilters } from './filters';
import { CasesGeneralList } from './list';
import { CasesGeneralFilter } from '../../../../shared/types/modules/cases-general';
import { useState } from 'react';

export const CasesGeneral = () => {
    const [filters, setFilters] = useState<CasesGeneralFilter>();

    return (
        <>
            <LayoutModule title="Búsqueda de casos generales">
                <CasesGeneralFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <CasesGeneralList filters={filters} />
        </>
    );
};
